import React from 'react';
import { BsQuestionSquareFill, BsKeyFill, BsExclamationCircleFill } from 'react-icons/bs';
import { FaBullseye } from 'react-icons/fa';

const FutureTreatment = () => {
    return (
        <section className="section future-treatment-section">
            <div className="container">
                <h2 className="section-title">Future Treatment of ADPKD --Gene Therapy</h2>
                
                <div className="future-grid top-grid">
                    <div className="info-card dark-card">
                        <div className="card-header-icon">
                            <BsQuestionSquareFill />
                            <h3 className="card-title">Why RNA-Based Therapies?</h3>
                        </div>
                        <p>The future of ADPKD treatment lies in RNA-based therapies that aim to restore or boost polycystin proteins at the cellular level. These innovative approaches target the root cause of the disease rather than just managing symptoms.</p>
                    </div>
                    <div className="info-card">
                        <div className="card-header-icon">
                            <BsKeyFill />
                            <h3 className="card-title">Key Challenges</h3>
                        </div>
                        <ul className="two-column-list">
                            <li>Long-term safety evaluation</li>
                            <li>Delivery to kidney cells</li>
                            <li>Manufacturing complexity</li>
                            <li>Regulatory approval timeline</li>
                        </ul>
                    </div>
                </div>

                <div className="info-card wide-card">
                    <h3 className="card-title treatment-title">Types of RNA based Therapy</h3>
                    <div className="grid-container-3">
                        <div>
                            <h4>ASOs (Antisense Oligonucleotides)</h4>
                            <ul>
                                <li>Target specific RNA sequences</li>
                                <li>Modify protein production</li>
                                <li>Delivered directly to kidney cells</li>
                                <li>Early clinical trials show promise</li>
                            </ul>
                        </div>
                        <div>
                            <h4>mRNA Therapy</h4>
                            <ul>
                                <li>Deliver functional protein instructions</li>
                                <li>Restore normal polycystin levels</li>
                                <li>Bypass genetic mutations</li>
                                <li>Revolutionary approach to treatment</li>
                            </ul>
                        </div>
                        <div>
                            <h4>RNA Interference (RNAi / siRNA)</h4>
                            <ul>
                                <li>Silence disease-causing genes</li>
                                <li>Use RNA interference pathway</li>
                                <li>Potential to slow cyst growth</li>
                                <li>Precision targeting of PKD pathways</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="future-grid bottom-grid">
                    <div className="info-card">
                        <div className="card-header-icon">
                            <FaBullseye />
                            <h3 className="card-title">Why there is Promise?</h3>
                        </div>
                        <ul className="two-column-list">
                            <li>Target root genetic cause</li>
                            <li>Less systemic side effects</li>
                            <li>Precision medicine</li>
                            <li>Restore kidney function</li>
                        </ul>
                    </div>
                    <div className="info-card dark-card">
                        <div className="card-header-icon">
                           <BsExclamationCircleFill />
                            <h3 className="card-title">Clinical Trials & Participation</h3>
                        </div>
                        <p>Most RNA-based therapies are in early-phase clinical trials. Participation eligibility varies by study, and genetic testing may be required. Stay informed about trial opportunities through your healthcare team and patient advocacy organizations.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FutureTreatment;